import { useEffect, useState } from "react";
import Loader from "../../shared/Loader";
import StatsService from "../../../services/v2/outbound/stats-service";

const GeneralData = ({ filters, setIsUnauthorized }) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    setLoading(true);
    setError(false);
    setData();

    StatsService.outboundGeneral(filters)
      .then(({ data: { data } }) => {
        setData(data);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          setIsUnauthorized(true);
        }
        setError(true);
        setLoading(false);
      });
  }, [filters]);

  const renderPanel = (title, content, key, total, className = "") => (
    <div
      key={key}
      className={`bg-primary-light dark:bg-primary-dark dark:text-text-primary-dark rounded-lg shadow-lg flex flex-col items-center justify-center ${className}`}
    >
      {loading ? (
        <Loader />
      ) : error ? (
        <div className="text-red-500 text-sm font-semibold text-center">
          Some error occurred loading data
        </div>
      ) : (
        <>
          <h4 className="text-sm font-semibold text-center">{title}</h4>
          <div className="text-3xl font-bold">{content}</div>
          {total && (
            <div className="text-xs text-gray-500">
              Total {key} time: {total}
            </div>
          )}
        </>
      )}
    </div>
  );

  return (
    <div className="grid grid-cols-[auto,1fr] sm:grid-cols-[auto,repeat(5,1fr)] gap-4">
      {/* Panel Total Calls con ancho fijo */}
      {renderPanel(
        "Total Calls",
        data?.totalCalls,
        "totalCalls",
        null,
        "lg:w-64"
      )}

      {/* Panel ASR */}
      <div className="bg-primary-light dark:bg-primary-dark dark:text-text-primary-dark px-2 py-2 rounded-lg shadow-lg flex h-32">
        {loading ? (
          <div className="flex items-center justify-center w-full">
            <Loader />
          </div>
        ) : error ? (
          <div className="flex items-center justify-center w-full h-full">
            <div className="text-red-500 text-sm font-semibold text-center">
              Some error occurred loading data
            </div>
          </div>
        ) : (
          <>
            <div className="flex flex-col justify-end w-2 bg-gray-300 rounded-full">
              <div
                className="bg-[#54B399] rounded-full"
                style={{ height: `${data?.attended?.percentage}%` }}
              ></div>
            </div>
            <div className="flex-1 flex flex-col justify-between ml-2">
              <h4 className="text-xl font-normal text-left">Attended</h4>
              <div className="text-right">
                <div className="text-3xl font-bold">
                  {data?.attended?.percentage}%
                </div>
                <div className="text-sm">
                  {data?.attended?.value} Attended Calls
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Panel canceled Rate */}
      <div className="bg-primary-light dark:bg-primary-dark dark:text-text-primary-dark px-2 py-2 rounded-lg shadow-lg flex h-32">
        {loading ? (
          <div className="flex items-center justify-center w-full">
            <Loader />
          </div>
        ) : error ? (
          <div className="flex items-center justify-center w-full h-full">
            <div className="text-red-500 text-sm font-semibold text-center">
              Some error occurred loading data
            </div>
          </div>
        ) : (
          <>
            <div className="flex flex-col justify-end w-2 bg-gray-300 rounded-full">
              <div
                className="bg-[#6092C0] rounded-full"
                style={{ height: `${data?.canceled?.percentage}%` }}
              ></div>
            </div>
            <div className="flex-1 flex flex-col justify-between ml-2">
              <h4 className="text-xl font-normal text-left">Canceled</h4>
              <div className="text-right">
                <div className="text-3xl font-bold">
                  {data?.canceled?.percentage}%
                </div>
                <div className="text-sm">
                  {data?.canceled?.value} Canceled Calls
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Panel nonAttended */}
      <div className="bg-primary-light dark:bg-primary-dark dark:text-text-primary-dark px-2 py-2 rounded-lg shadow-lg flex h-32">
        {loading ? (
          <div className="flex items-center justify-center w-full">
            <Loader />
          </div>
        ) : error ? (
          <div className="flex items-center justify-center w-full h-full">
            <div className="text-red-500 text-sm font-semibold text-center">
              Some error occurred loading data
            </div>
          </div>
        ) : (
          <>
            <div className="flex flex-col justify-end w-2 bg-gray-300 rounded-full">
              <div
                className="bg-[#9170B8] rounded-full"
                style={{ height: `${data?.nonAttended?.percentage}%` }}
              ></div>
            </div>
            <div className="flex-1 flex flex-col justify-between ml-2">
              <h4 className="text-xl font-normal text-left">Non Attended</h4>
              <div className="text-right">
                <div className="text-3xl font-bold">
                  {data?.nonAttended?.percentage}%
                </div>
                <div className="text-sm">
                  {data?.nonAttended?.value} Non Attended Calls
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Panel Avg Talk Time */}
      {renderPanel(
        "AVG Talk Time",
        data?.duration?.average,
        "talk",
        data?.duration?.total
      )}

      {/* Panel Avg Ringing Time */}
      {renderPanel(
        "AVG Ringing Time",
        data?.ringingTime?.average,
        "ringing",
        data?.ringingTime?.total
      )}
    </div>
  );
};

export default GeneralData;
